import { render, staticRenderFns } from "./MaterialColorsPopup.vue?vue&type=template&id=22dd87a4&"
import script from "./MaterialColorsPopup.vue?vue&type=script&lang=js&"
export * from "./MaterialColorsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports